module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_01-4-ed44a95985560b75d7dfa743d8f03cb7.png";